import React from 'react';

export const filterChildrenByDisplayName = (children, displayName) => {
  const childrenArray = React.Children.toArray(children);
  const child: any = childrenArray.find((child: any) => child?.type?.displayName === displayName);
  return child;
};
